( ( $ ) => {

	const $mainMenu = $( '.main-menu' );
	if ( $mainMenu.length ) {
		// lets set current active item to be underlined.
		const $currentEl = $( `a[href="${ window.location.href }"]`, $mainMenu ).first();
		$currentEl.addClass( 'is-current' );
		$currentEl.parentsUntil( '.main-menu', '.menu-item-has-children' ).each( ( index, el ) => {
			$( el ).children( '.nav-link' ).addClass( 'is-current' );
		} )
	}

} )( jQuery )